export const REMINDER_TYPES = {
  INTERVAL: 'interval',
  MONTHLY_DATE: 'monthly_date',
  WEEKLY: 'weekly',
  MONTHLY_WEEKDAY: 'monthly_weekday',
}

export const DAYS_OF_WEEK = [
  'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
]

export const WEEK_ORDINALS = [
  { value: 1, label: 'First' },
  { value: 2, label: 'Second' },
  { value: 3, label: 'Third' },
  { value: 4, label: 'Fourth' },
  { value: -1, label: 'Last' },
]
